import { useContext, useState } from "react";
import Popup from "reactjs-popup";
import { PipelineStageEditorContext } from "../../../../context/Contexts";
import { debounce } from "../../../../utils/debounce";
import { TextFrame } from "../../../modal-dialog/VerifyFrame";
import "./EditLimitStage.scss";

const debounce1000 = debounce((callback, ...args) => {
    callback(args);
}, 1000);

export const EditLimitStage = (props) => {

    const stageContext = useContext(PipelineStageEditorContext);
    const stage = stageContext.stage;
    const [n, setN] = useState(stage.data?.$limit);

    

    const save = (val) => {
        try{
            const i = parseInt(val);
            stageContext.replaceStageData({ $limit: i });
        }
        catch{}
    }

    return <div className="edit-limit-stage">
        {/* <p>
            Limits the number of records that flow into subsequent stages.
        </p> */}
        Limit: 
        &nbsp;
        <Popup
            modal
            keepTooltipInside
            trigger={
                <span className="value-box">
                    {n}
                </span>        
            }
        >
            {closeModal => <TextFrame
                title={"Edit value"}
                label={`Limit:`}
                initialTextValue={`${n}`}
                close={closeModal} confirmed={async (text) => {
                    try{
                        const newVal = parseInt(text);
                        setN(newVal);
                        save(newVal);
                    }
                    catch(err){
                        alert(err.message);
                    }
                    closeModal();
                }}
            />}
        </Popup>
        
        &nbsp; record(s) max.
    </div>
    
}